/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ScholarshiptypeIdAttachedPeople200,
  GetApiV1ScholarshiptypeIdAttachedPeople401,
  GetApiV1ScholarshiptypeIdAttachedPeople500,
  GetApiV1ScholarshiptypeIdAttachedPeoplePathParams,
  GetApiV1ScholarshiptypeIdAttachedPeopleQueryParams,
  GetApiV1ScholarshiptypeIdAttachedPeopleQueryResponse,
} from "../../types/scholarshipTypeVnculoDePessoasController/GetApiV1ScholarshiptypeIdAttachedPeople.ts";
import { scholarshipTypeAttachedPersonViewModelSchema } from "../scholarshipTypeAttachedPersonViewModelSchema.ts";

export const getApiV1ScholarshiptypeIdAttachedPeoplePathParamsSchema = z.object(
  {
    id: z.coerce.number().int(),
  },
) as unknown as ToZod<GetApiV1ScholarshiptypeIdAttachedPeoplePathParams>;

export const getApiV1ScholarshiptypeIdAttachedPeopleQueryParamsSchema = z
  .object({
    studentId: z.optional(z.coerce.number().int()),
    classStudentId: z.optional(z.coerce.number().int()),
    discountPercentage: z.optional(z.coerce.number()),
    enrollmentStatus: z.optional(z.coerce.number().int()),
  })
  .optional() as unknown as ToZod<GetApiV1ScholarshiptypeIdAttachedPeopleQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ScholarshiptypeIdAttachedPeople200Schema = z.array(
  z.lazy(() => scholarshipTypeAttachedPersonViewModelSchema),
) as unknown as ToZod<GetApiV1ScholarshiptypeIdAttachedPeople200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ScholarshiptypeIdAttachedPeople401Schema =
  z.any() as unknown as ToZod<GetApiV1ScholarshiptypeIdAttachedPeople401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ScholarshiptypeIdAttachedPeople500Schema =
  z.any() as unknown as ToZod<GetApiV1ScholarshiptypeIdAttachedPeople500>;

export const getApiV1ScholarshiptypeIdAttachedPeopleQueryResponseSchema =
  z.lazy(
    () => getApiV1ScholarshiptypeIdAttachedPeople200Schema,
  ) as unknown as ToZod<GetApiV1ScholarshiptypeIdAttachedPeopleQueryResponse>;
